import { z } from "zod";

export const machineSelectionWithCheckedSchema = z.object({
	id: z.string(),
	alias: z.string(),
	utcDateTime: z.string().optional(),
	checked: z.boolean(),
	isProduction: z.boolean().default(true),
});
